import React, { useState, useContext, useEffect } from 'react';
import { useParams, Redirect } from "react-router-dom";
import axios from 'axios';
import { AppContext } from "AppContext";

const Submitted = (props) => {

    const { config } = useContext(AppContext);
    const params = useParams();

    const [order_failed, set_order_failed] = useState("");
    const [redirect, set_redirect] = useState({})

    const queryString = window.location.search;
    const urlParams = new URLSearchParams(queryString);
    const sessionId = urlParams.get('session_id');

    useEffect(()=>{ 
        const action = async () => {
            let order_record;
            try {
                order_record = await axios.get(config.api.base + '/orders/' + params.id);
            } catch(err) {
                console.log(err.response);
                if (err.response.status === 500) set_order_failed("id");
                return;
            }

            if (order_record.data.payment_intent !== null) {
                try {
                    const checkout_api_response = await axios.get(config.api.base + '/checkout/session-status/' + sessionId);
                    console.log(checkout_api_response);
                    if (checkout_api_response.data.status !== "complete" || checkout_api_response.data.payment_status !== "paid") {
                        set_order_failed("payment"); 
                        return;
                    }
                } catch(err) {
                    console.log(err.response);
                    if (err.response.status === 502) set_order_failed("payment"); 
                    return;
                }
            }

            set_order_failed("");
        }
        action();
    }, [config.api.base, sessionId, params.id])

    function on_clicked_exit(e) {
        set_redirect({ path: "/dashboard/orders"})
        //return <Redirect to={state.context.redirect}/>
    }

    if(redirect.path) {
        return <Redirect to={redirect.path}/>
    }

    return (
        <div className="min-h-screen flex justify-center bg-gray-50 pt-24 px-4 sm:px-6 lg:px-8">
            <div className="max-w-2xl w-full flex flex-wrap flex-col items-center mt-14 space-y-8">
                <h2 className="text-center text-3xl font-extrabold text-gray-900">
                    {
                        order_failed === "payment" ?
                        "We ran into a payment error" :
                        order_failed === "id" ?
                        "This order does not exist." :
                        "Your order has been submitted."
                    }
                    <br/>
                    ID: {params.id}
                </h2>
                <div className="max-w-xl">
                    <p className={"text-center text-xl text-gray-700" + (order_failed === "payment" ? "" : " hidden")}>
                        Your order has been placed. However, your payment has failed.<br/>
                        A member of our team at <a className="underline" href="mailto:jobtravelers@abcorp.com">jobtravelers@abcorp.com</a> will reach out to you shortly to complete your transaction.<br/>
                    </p>
                    <p className={"text-center text-xl text-gray-700" + (order_failed === "id" ? "" : " hidden")}>
                        You may have been directed to this screen in error.<br/>
                        Click the button below to be redirected to your Orders page.<br/>
                    </p>
                    <p className={"text-center text-xl text-gray-700" + (order_failed === "" ? "" : " hidden")}>
                        You will receive an order confirmation email shortly.<br/>
                        If you have not received any correspondence from us, please check your spam or junk mail folders.<br/>
                        Else, please reach out to us at <a className="underline" href="mailto:jobtravelers@abcorp.com">jobtravelers@abcorp.com</a>.
                    </p>
                </div>
                <div className={"flex justify-center w-full"}>
                    <button className={"uploadButton"} onClick={on_clicked_exit}>
                        Okay
                    </button>
                </div>
            </div>
        </div>
    )
}

export default Submitted;